import type { GetConversationAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetConversationAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetConversationAuditByIdArgs = {
  id: string;
};

export const useGetConversationAuditById = createQueryHook<
  UseGetConversationAuditByIdArgs,
  GetConversationAuditByIdResponseRow[],
  AuditLogQueryResult<'conversation_audit', GetConversationAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getConversationAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ conversation_audit: data }),
  graphqlDocument: GetConversationAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
